import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { StickyMiniCart } from './configurator/StickyMiniCart';

const API = process.env.REACT_APP_BACKEND_URL;
const DISMISS_KEY = 'fuelx_sticky_cart_dismissed_v1';
const EXCLUDED = new Set(['/', '/warenkorb']);

/** Globaler Sticky-Warenkorb: erscheint auf allen öffentlichen Seiten sobald der Kunde runterscrollt. */
export default function GlobalStickyCart() {
  const { pathname } = useLocation();
  const { config, openCart, isOpen } = useCart();
  const [result, setResult] = useState(null);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.sessionStorage?.getItem(DISMISS_KEY) === '1';
  });

  const mode = config?.mode || 'private';
  const vehicles = config?.vehicles || 1;
  const annualKm = config?.annualKm || 15000;
  const employees = config?.employees || 0;
  const isPvt = mode === 'private';
  const excluded = EXCLUDED.has(pathname);

  useEffect(() => {
    if (excluded || dismissed) {
      setVisible(false);
      return undefined;
    }
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [excluded, dismissed, pathname]);

  useEffect(() => {
    if (excluded || dismissed || !visible) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API}/api/calculator/calculate`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customer_type: mode,
            vehicles,
            annual_km: annualKm,
            employees: mode === 'business' ? employees : 0,
          }),
        });
        const data = await res.json();
        if (!cancelled) setResult(data);
      } catch (e) {
        console.error('[GlobalStickyCart]', e);
      }
    })();
    return () => { cancelled = true; };
  }, [visible, excluded, dismissed, mode, vehicles, annualKm, employees]);

  const dismiss = () => {
    if (typeof window !== 'undefined') window.sessionStorage?.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  const checkout = () => {
    openCart({
      mode, vehicles, annualKm, employees,
      cardFee: result?.card_fee,
      tankCredit: result?.tank_credit,
    });
  };

  if (excluded || dismissed || !visible || !result || isOpen) return null;

  return (
    <StickyMiniCart
      result={result}
      isPvt={isPvt}
      cardName={isPvt ? 'Silver Card' : 'Gold Card'}
      cardImgFront={isPvt ? '/silver-card-front.webp' : '/gold-card-front.webp'}
      annualKm={annualKm}
      vehicles={vehicles}
      totalAmount={Number(result?.card_fee) || 0}
      loading={false}
      fmt={(v, d = 2) => Number(v || 0).toLocaleString('de-DE', { minimumFractionDigits: d })}
      onCheckout={checkout}
      onDismiss={dismiss}
    />
  );
}
